const safeParse = (value) => {
  try {
    return JSON.parse(value)
  } catch {
    return null
  }
}

export const resolveTenantSubdomainFromStorage = ({ isDev, hostname, storage }) => {
  const invalidTenants = new Set(['app', 'www', 'api'])

  if (isDev) {
    invalidTenants.add('staging-app')
    invalidTenants.add('staging-api')
    invalidTenants.add('localhost')
  }

  if (isDev) {
    const sub = String(hostname || '')
      .toLowerCase()
      .split('.')[0]
    if (!invalidTenants.has(sub)) {
      return sub
    }
  }

  const storedTenantSubdomain =
    storage.getItem('activeTenantSubdomain') || storage.getItem('tenantSubdomain') || null

  if (storedTenantSubdomain) {
    return storedTenantSubdomain
  }

  const storedUser = safeParse(storage.getItem('user'))
  const userTenantSubdomain =
    storedUser?.tenant?.subdomain ??
    storedUser?.activeTenant?.subdomain ??
    storedUser?.tenantSubdomain ??
    storedUser?.tenant_subdomain ??
    null

  if (typeof userTenantSubdomain === 'string' && userTenantSubdomain.trim()) {
    return userTenantSubdomain.trim().toLowerCase()
  }

  return null
}
